import { getField, updateField } from "vuex-map-fields";

import API from "@/api";

export const state = () => ({
  // table
  jobNotifications: [],
  jobNotificationsTypes: [],
  jobNotificationsTypesMap: {},
  selectedSearchJob: null,
  selectedJobNotificationsTypes: null,
  textSearchJobNotification: null,
  loadingTable: false,

  // paginacao
  pagination: {
    size: 10,
    totalPages: 0,
    totalElements: 0,
    offset: 0,
  },
  currentPage: 1,
});

function formatJobNotificationTypes(state, statusCode) {
  if (Object.keys(state.jobNotificationsTypesMap).length === 0) {
    return statusCode;
  } else {
    return state.jobNotificationsTypesMap[statusCode];
  }
}

export const getters = {
  getField,
  formatJobNotificationTypes: (state) => (code) =>
    formatJobNotificationTypes(state, code),
};

function mountSearchPayload(state) {
  const config = {
    params: new URLSearchParams(),
  };

  config.params.append("size", state.pagination.size);
  config.params.append("page", state.currentPage - 1);
  // config.params.append("sort", "notificacaoName");

  if (state.selectedSearchJob) {
    config.params.append("dsJob", state.selectedSearchJob.toString());
  }
  if (state.selectedJobNotificationsTypes) {
    config.params.append(
      "type",
      state.selectedJobNotificationsTypes.toString()
    );
  }

  if (state.textSearchJobNotification) {
    config.params.append(
      "notificacaoName",
      state.textSearchJobNotification.toString()
    );
  }

  if (state.selectedDtRequest) {
    if (state.selectedDtRequest.length === 1) {
      config.params.append("dtInicExec", state.selectedDtRequest[0]);
    } else if (state.selectedDtRequest.length === 2) {
      config.params.append("dtInicExec", state.selectedDtRequest[0]);
      config.params.append("dtFimExec", state.selectedDtRequest[1]);
    }
  }

  return config;
}

function objectToMap(notificationTypes) {
  let map = {};
  notificationTypes.forEach((elem) => {
    map[elem.code] = elem.label;
  });
  return map;
}

export const actions = {
  async get({ dispatch, state, commit, rootState }, payload) {
    commit("updateField", { path: "pagination.offset", value: 0 });
    // commit("updateField", { path: "loadingTable", value: true });
    commit("updateField", { path: "jobNotifications", value: [] });
    commit("updateField", { path: "currentPage", value: 1 });
    // commit("updateField", { path: "totalPages", value: 0 });
    const result = await API.axios.get(
      "/bff/api/v1/rotina-notificacoes",
      mountSearchPayload(state)
    );
    if (!result) {
      commit("updateField", { path: "loadingTable", value: false });
      return undefined;
    } else if (result.status >= 400 && result.status <= 600) {
      commit("updateField", { path: "loadingTable", value: false });
      return result;
    } else if (result.data?.totalElements > 0) {
      commit("updateField", { path: "currentPage", value: 1 });
    } else {
      commit("updateField", { path: "currentPage", value: 0 });
      commit("updateField", { path: "pagination.totalPages", value: 0 });
      commit("updateField", { path: "pagination.offset", value: 0 });
    }

    // total number of items
    if (result.data.totalElements) {
      commit("updateField", {
        path: "pagination.totalElements",
        value: result.data.totalElements,
      });
      commit("updateField", {
        path: "pagination.totalPages",
        value: result.data.totalPages,
      });
    }
    if (result.data.content) {
      commit("updateField", {
        path: "jobNotifications",
        value: result.data.content,
      });
    }

    commit("updateField", { path: "loadingTable", value: false });
    return result;
  },

  async getPage({ state, commit, rootState }, payload) {
    commit("updateField", { path: "loadingTable", value: true });
    const result = await API.axios.get(
      "/bff/api/v1/rotina-notificacoes",
      mountSearchPayload(state)
    );

    if (!result) {
      commit("updateField", { path: "loadingTable", value: false });
      return undefined;
    } else if (result.status >= 400 && result.status <= 600) {
      commit("updateField", { path: "loadingTable", value: false });
      return result;
    } else if (result.data?.content) {
      // update table items
      commit("updateField", {
        path: "jobNotifications",
        value: result.data.content,
      });
      commit("updateField", {
        path: "pagination.offset",
        value: result.data.pageable.offset,
      });
    }
    commit("updateField", { path: "loadingTable", value: false });
    return result;
  },

  async getTypes({ dispatch, state, commit, rootState }, payload) {
    const result = await API.axios.get(`/bff/api/v1/rotina-notificacoes/list`);
    // ifs de status
    if (!result || (result.status >= 400 && result.status < 600)) {
      return !result ? undefined : result;
    } else if (!result.data.empty) {
      commit("updateField", {
        path: "jobNotificationsTypes",
        value: result.data,
      });
      commit("updateField", {
        path: "jobNotificationsTypesMap",
        value: objectToMap(result.data),
      });
    }
    return result;
  },

  async addJobNotification({ dispatch, state }, { jobNotificationForm }) {
    const response = await API.axios.post(
      `/bff/api/v1/rotina-notificacoes`,
      jobNotificationForm
    );
    return response;
  },

  async updateJobNotification({ dispatch, state }, { jobNotificationForm }) {
    const response = await API.axios.put(
      `/bff/api/v1/rotina-notificacoes/${jobNotificationForm.idNotificacao}`,
      jobNotificationForm
    );
    return response;
  },

  async deleteJobNotification({ dispatch, state }, idNotificacao) {
    const response = await API.axios.delete(
      `/bff/api/v1/rotina-notificacoes/${idNotificacao}`
    );
    return response;
  },

  async getFluxo({ dispatch, state }, idNotificacao) {
    const response = await API.axios.get(
      `/bff/api/v1/rotina-notificacoes/${idNotificacao}/fluxo`
    );

    const fluxoSorted = response.data.sort((a, b) => {
      return a.ordem - b.ordem;
    });
    return fluxoSorted;
  },

  async postFluxo({ dispatch, state }, { fluxoForm = [], idNotificacao }) {
    const response = await API.axios.post(
      `/bff/api/v1/rotina-notificacoes/${idNotificacao}/fluxo`,
      fluxoForm
    );
    return response;
  },
};

export const mutations = {
  updateField,
  setItemsPerPage(state, payload) {
    state.pagination.size = payload;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
